import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeAssetGroupsDropdown()
  }

  initializeAssetGroupsDropdown = async () => {
    const dropdown = document.querySelector(
      "#asset_group_kind"
    ) as HTMLSelectElement

    if (!dropdown) return

    const updateDropdown = () => {
      document.querySelectorAll(".conditional-input").forEach((e) => {
        e.classList.add("hidden")
      })

      // Kind-agnostic on purpose: every asset-group kind comes in a global
      // flavour (one "world" file) and a `localized_` flavour (one file per
      // locale) — image, audio, video and whatever comes next.
      const dropdownValue = dropdown?.value ?? ""
      const selector = dropdownValue.startsWith("localized_")
        ? ".localized"
        : ".globalized"

      document.querySelectorAll(selector).forEach((e) => {
        e.classList.remove("hidden")
      })
    }

    updateDropdown()
    dropdown.addEventListener("change", updateDropdown)
  }
}
